export enum NeedsType {
  tg_sensor = 'tg_sensor',
  phase = 'phase',
}
